module.exports = __webpack_public_path__ + "static/media/technical_support_fundamentals.ee895385.png";